import PropTypes from 'prop-types';
import React from 'react';

export const PositionBreakPriceWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'POSITION_BREAK_PRICE',
    category: 'Exit',
    type: 'Position Break Price',
    domain: 'Price',
  };
  const priceToBreak = softOrder.priceToBreak;
  return <Component details={details} priceToBreak={priceToBreak} {...rest} />;
};

PositionBreakPriceWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    priceToBreak: PropTypes.any
  })
};
